/* CAFFREY collection pages — quick-add sheet + "Find your insole" filter (Claude Code, launch foundation 7, 2026-10-06).
   Progressive: without JS the "Choose size" link opens the product page and the need row is hidden.
   Add to cart itself is Dawn's <product-form> (AJAX + cart notification); this file only opens/closes the sheet,
   copies the chosen variant into the form and keeps the need filter applied when Dawn's facets re-render the grid. */
(function () {
  'use strict';
  if (window.__cfCollection) return;
  window.__cfCollection = true;

  var doc = document;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- quick-add sheet ---------- */
  function openSheet(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    try {
      dialog._cfOpener = opener || null;
      var err = dialog.querySelector('.product-form__error-message-wrapper');
      if (err) err.hidden = true;
      dialog.showModal();
    } catch (e) {
      return false;
    }
    doc.documentElement.classList.add('cf-qa-lock');
    var target = dialog.querySelector('.cf-qa__chip input:checked') || dialog.querySelector('.cf-qa__chip input:not([disabled])');
    if (target) {
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }
    return true;
  }

  function closeOpenSheets(returnFocusToCart) {
    var open = doc.querySelectorAll('dialog.cf-qa[open]');
    for (var i = 0; i < open.length; i++) {
      var d = open[i];
      var opener = d._cfOpener;
      d.close();
      if (returnFocusToCart && opener) {
        var cart = doc.querySelector('cart-notification') || doc.querySelector('cart-drawer');
        if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(opener);
      }
    }
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var opener = t.closest('[data-cf-qa-open]');
    if (opener) {
      var dlg = doc.getElementById(opener.getAttribute('data-cf-qa-open'));
      if (dlg && openSheet(dlg, opener)) e.preventDefault();
      return;
    }

    if (t.closest('[data-cf-qa-close]')) {
      var d = t.closest('dialog');
      if (d) d.close();
      return;
    }

    if (t.matches && t.matches('dialog.cf-qa')) {
      var panel = t.querySelector('.cf-qa__panel');
      if (panel) {
        var r = panel.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) t.close();
      }
      return;
    }

    var submit = t.closest('[data-cf-qa-submit]');
    if (submit && submit.getAttribute('aria-disabled') === 'true') {
      var sheet = submit.closest('dialog');
      var hint = sheet && sheet.querySelector('[data-cf-qa-hint]');
      if (hint) {
        hint.hidden = false;
        hint.classList.remove('is-flash');
        void hint.offsetWidth;
        hint.classList.add('is-flash');
      }
      var first = sheet && sheet.querySelector('.cf-qa__chip input:not([disabled])');
      if (first) first.focus();
    }
  });

  doc.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.cf-qa__chip input[type="radio"]')) return;
    var sheet = input.closest('dialog');
    if (!sheet) return;
    var idField = sheet.querySelector('[data-cf-qa-id]');
    if (idField) idField.value = input.value;
    var submit = sheet.querySelector('[data-cf-qa-submit]');
    if (submit) submit.removeAttribute('aria-disabled');
    var price = sheet.querySelector('[data-cf-qa-price]');
    var p = input.getAttribute('data-cf-qa-price');
    if (price && p) price.textContent = p;
    var hint = sheet.querySelector('[data-cf-qa-hint]');
    if (hint) hint.hidden = true;
    var err = sheet.querySelector('.product-form__error-message-wrapper');
    if (err) err.hidden = true;
  });

  doc.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('dialog.cf-qa')) {
      if (!doc.querySelector('dialog.cf-qa[open]')) doc.documentElement.classList.remove('cf-qa-lock');
    }
  }, true);

  function hookCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { closeOpenSheets(true); });
    return true;
  }
  if (!hookCart()) doc.addEventListener('DOMContentLoaded', hookCart, { once: true });

  /* ---------- need / task filter ---------- */
  var current = '';

  function root() { return doc.querySelector('[data-cf-needs]'); }

  function gridItems() {
    var grid = doc.getElementById('product-grid');
    return grid ? grid.querySelectorAll('.cf-col-cards__item') : [];
  }

  function textEl(tag, cls, text) {
    var el = doc.createElement(tag);
    if (cls) el.className = cls;
    if (text) el.textContent = text;
    return el;
  }

  function renderStatus(r, btn, shown) {
    var status = doc.querySelector('[data-cf-need-status]');
    if (!status) return;
    status.textContent = '';
    if (!current || !btn) { status.hidden = true; return; }
    var label = btn.getAttribute('data-cf-need-label') || '';
    var hint = btn.getAttribute('data-cf-need-hint') || '';
    var main = textEl('p', 'cf-col-status__main');
    if (shown > 0) {
      var tpl = r.getAttribute('data-cf-tpl-showing') || '[count] · [label]';
      var parts = tpl.split('[label]');
      main.appendChild(doc.createTextNode(parts[0].replace('[count]', shown)));
      main.appendChild(textEl('strong', '', label));
      if (parts[1]) main.appendChild(doc.createTextNode(parts[1].replace('[count]', shown)));
      if (hint) {
        main.appendChild(doc.createTextNode(' '));
        main.appendChild(textEl('span', 'cf-col-status__hint', '— ' + hint));
      }
    } else {
      main.textContent = r.getAttribute('data-cf-tpl-none') || '';
    }
    status.appendChild(main);
    var extra = r.querySelector('template[data-cf-need-extra="' + (window.CSS && CSS.escape ? CSS.escape(current) : current) + '"]');
    if (extra && extra.content) status.appendChild(extra.content.cloneNode(true));
    var clear = textEl('button', 'cf-col-status__clear', r.getAttribute('data-cf-tpl-clear') || 'Show all');
    clear.type = 'button';
    clear.setAttribute('data-cf-need', '');
    status.appendChild(clear);
    status.hidden = false;
  }

  function applyNeed(slug, opts) {
    var r = root();
    if (!r) return;
    opts = opts || {};
    var btns = r.querySelectorAll('.cf-col-needs__list [data-cf-need]');
    var btn = null;
    for (var i = 0; i < btns.length; i++) {
      if ((btns[i].getAttribute('data-cf-need') || '') === (slug || '')) btn = btns[i];
    }
    if (!btn) { slug = ''; btn = r.querySelector('.cf-col-needs__list [data-cf-need=""]'); }
    current = slug || '';
    for (var j = 0; j < btns.length; j++) btns[j].setAttribute('aria-pressed', btns[j] === btn ? 'true' : 'false');

    var ids = current && btn ? (btn.getAttribute('data-cf-need-ids') || '').split(',').filter(Boolean) : null;
    var items = gridItems();
    var shown = 0;
    for (var k = 0; k < items.length; k++) {
      if (!ids || ids.indexOf(items[k].getAttribute('data-cf-pid')) > -1) shown++;
    }
    var toggle = function () {
      for (var m = 0; m < items.length; m++) {
        var on = !ids || ids.indexOf(items[m].getAttribute('data-cf-pid')) > -1;
        items[m].hidden = !on;
      }
    };
    if (opts.animate && !reduceMotion && typeof doc.startViewTransition === 'function') {
      try { doc.startViewTransition(toggle); } catch (e) { toggle(); }
    } else {
      toggle();
    }
    renderStatus(r, btn, shown);

    if (opts.history !== false && window.history && history.replaceState) {
      var url = location.pathname + location.search + (current ? '#need-' + current : '');
      try { history.replaceState(history.state, '', url); } catch (e) {}
    }
  }

  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cf-need]') : null;
    if (!b || !root()) return;
    e.preventDefault();
    var slug = b.getAttribute('data-cf-need') || '';
    var fromStatus = !!b.closest('[data-cf-need-status]');
    applyNeed(slug, { animate: true });
    if (fromStatus) {
      var r = root();
      var all = r && r.querySelector('.cf-col-needs__list [data-cf-need=""]');
      if (all) all.focus();
    }
  });

  function init() {
    var r = root();
    if (!r) return;
    var h = (location.hash || '').replace(/^#/, '');
    if (h.indexOf('need-') === 0) applyNeed(decodeURIComponent(h.slice(5)), { history: false });
    var container = doc.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      new MutationObserver(function () {
        if (current) applyNeed(current, { history: false });
      }).observe(container, { childList: true });
    }
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
